import { CalendarOutlined } from "@ant-design/icons";
import  ErrorContainer  from "../common/ErrorContainer";
import { cn } from "../helper/classNames";
import { DatePicker, DatePickerProps } from "antd";
import { RangePickerProps } from "antd/es/date-picker";
import dayjs, { Dayjs } from "dayjs";
import { FC } from "react";

import CustomLabel  from "./CustomLabel";

type DateRenderFunction = (currentDate: Dayjs) => React.ReactNode;

export interface ICustomDatePicker {
  name?: string;
  label?: string;
  value?: any;
  format?: string;
  onChange?: DatePickerProps["onChange"];
  touched?: boolean | undefined;
  error?: string | undefined;
  disableDate?: RangePickerProps["disabledDate"];
  disabled?: boolean;
  required?: boolean;
  showTime?: boolean;
  allowClear?: boolean;
  dateRender?: DateRenderFunction;
  index?: number;
  isSearchWidget?: boolean;
  specificDateTime?: string;
  placeholder?: string;
  className?: string;
  datePickerClassName?: string;
  mode?: "time" | "date" | "month" | "year" | "decade",
}
const CustomDatePicker: FC<ICustomDatePicker> = (props) => {
  const {
    name = "",
    label = "",
    value = "",
    format = "DD/MM/YYYY",
    onChange = () => null,
    touched,
    error,
    disableDate,
    disabled = false,
    required,
    showTime = false,
    allowClear = true,
    placeholder,
    className = "",
    datePickerClassName = "",
  } = props;

  return (
    <div className={cn("w-full", className)}>
      {<CustomLabel
        label={label}
        required={required}
      />}
      <DatePicker
        id={name}
        name={name}
        className={cn("w-full cursor-pointer", datePickerClassName)}
        placeholder={placeholder}
        onChange={onChange}
        format={format}
        suffixIcon={<CalendarOutlined onPointerOverCapture={() => { }}
        onPointerMoveCapture={() => { }} />}
        disabledDate={disableDate}
        disabled={disabled}
        value={value === "" ? undefined : dayjs(value).isValid() ? dayjs(value) : undefined}

        showTime={showTime}
        allowClear={allowClear}
      />
      <ErrorContainer
        touched={touched}
        error={error}
      />
    </div>
  );
};

export default CustomDatePicker;
